<div class="lock-screen-wrapper">
  <div class="lock-screen-logo">
    <a><b>Kalem</b> LİSANS</a>
  </div>
  <div class="lock-screen-name">{{ user?.full_name }}</div>
  <div class="lock-screen-item">
    <div class="lock-screen-image">
      <img src="assets/img/avatars/empty.png" alt="User Image" />
    </div>
    <form class="lock-screen-credentials" #LockScreenForm="ngForm">
      <div
        class="input-group"
        [ngClass]="invalidPassword && Password.invalid ? 'error-input' : ''"
      >
        <input
          type="password"
          name="password"
          [(ngModel)]="password"
          class="form-control"
          (keydown.enter)="LockScreenForm.valid ? login() : null"
          #Password="ngModel"
          (ngModelChange)="invalidPassword = false"
          required
          placeholder="{{ translate('password') }}"
        />
        <div class="input-group-btn">
          <button
            type="button"
            class="btn"
            [disabled]="LockScreenForm.invalid"
            (click)="login()"
          >
            <i class="fal fa-arrow-right text-muted"></i>
          </button>
        </div>
      </div>
      <div *ngIf="invalidPassword && Password.invalid" class="errorMessage">
        {{ translate("important_area") }}
      </div>
    </form>
    <kl-alert
      [message]="alertMessage"
      type="error"
      [show]="apiError"
      (onClose)="apiError = false"
    ></kl-alert>
  </div>
  <div class="help-block text-center">
    {{ translate("enter_your_password_to_retrieve_your_session") }}
  </div>
  <div class="text-center">
    <a class="router-link" (click)="routerLink('/auth/login')">{{
      translate("or_sign_in_as_a_different_user")
    }}</a>
  </div>
  <div class="lock-screen-footer text-center">
    Copyright © 2018-{{ currentYear }}
    <b
      ><a href="https://www.kalemyazilim.com" class="text-black"
        >Kalem Yazılım</a
      ></b
    ><br />
    {{ translate("all_rights_reserved") }}
  </div>
</div>
